export default __webpack_public_path__ + "static/media/1.1a4f6177.png";